import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 11a3 3 0 0 1 3-3h1V7a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1h1a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm17-1H5a1 1 0 0 0-1 1v3h4v-1a1 1 0 1 1 2 0v1h4v-1a1 1 0 0 1 2 0v1h4v-3a1 1 0 0 0-1-1m-5 6h-4v1a1 1 0 1 1-2 0v-1H4v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3h-4v1a1 1 0 0 1-2 0zM8 7v1h8V7a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1"
    }, null, -1)
  ]))]))
}
export default { render: render }